export const PROFILE_HEIGHT = '100%';
export const DESKTOP_CONTENT_WIDTH = 795;
export const BUTTON_HEADER_MIN_HEIGHT = 28;
export const MAIN_HEADER_MIN_HEIGHT = 70;
export const DESKTOP_NAVIGATION_MENU_WIDTH = 375;
export const DESKTOP_NAVIGATION_MENU_RESPONSIVE_WIDTH = 268;
export const CONTAINER_WIDTH = 1440;
export const DESKTOP_NAVIGATION_MENU_HEIGHT = 115;
export const MOBILE_WIDTH = 768;
export const MARGIN_HEADER = 96;
